import { Switch as RNSwitch } from 'react-native';
import type { SwitchProps as RNSwitchProps } from 'react-native';

import { useTheme } from '../theme/ThemeProvider';

export type SwitchProps = RNSwitchProps;

export function Switch({ trackColor, ...rest }: SwitchProps) {
  const theme = useTheme();
  return (
    <RNSwitch
      trackColor={trackColor ?? { false: theme.colors.border, true: theme.colors.primary }}
      {...rest}
    />
  );
}
